import { render, staticRenderFns } from "./ClickTest.vue?vue&type=template&id=56ef089a&scoped=true"
import script from "./ClickTest.vue?vue&type=script&lang=js"
export * from "./ClickTest.vue?vue&type=script&lang=js"
import style0 from "./ClickTest.vue?vue&type=style&index=0&id=56ef089a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef089a",
  null
  
)

export default component.exports